module.exports = __webpack_public_path__ + "static/media/friendactive.744bd2b5.svg";